import api from "@/libs/axios";
import { InformationOperationnelleCle } from "../models/informationsOperationnelles/informationOperationnelle";

const resource = "InformationsOperationnelles";

export default class InformationsOperationnellesRessources {
  public async list(): Promise<InformationOperationnelleCle[]> {
    const params = new URLSearchParams();

    const response = await api.get(`${resource}`, { params: params });
    return response.data;
  }
}
